import React, { useEffect } from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { trackUserIp } from './Utils/EventSourcing';

import CourseListing from './courses/CourseListing';
import InstructorsDetail from './instructor_new/InstructorDetail';
import Instructors from './instructor_new/InstructorListing';
import FaqNew from './landing_new/FaqNew';
import KontakPage from './landing_new/KontakPage';
import LandingPageNew from './landing_new/LandingPageNew';
import MarkAttendance from './landing_new/MarkAttendance';

import CheckoutPage from './checkout_new/Checkout';
import OrderDetail from './checkout_new/OrderDetail';
import WAButton from './components/WAButton';

import OnBoardingRegister from './components/LogInRegisterModal/OnBoardingRegister';

import CertificateVerify from './CertificateVerify/';
import VerifyLoginVoucherLayout from './containers/VerifyLoginVoucherLayout';
import VerifyVoucherLayout from './containers/VerifyVoucherLayout';
import CourseDetail from './courses/CourseDetailNew';

import CourseHostedLogin from './courses/CourseHostedLogin';

import DetailInternPage from './InternPage/Detail';
import InternPage from './InternPage/Main';

import StudentDashboard from './studentprofile_new/StudentDashboard';

import ProtectedRoute from './Route/ProtectedRoute';

import createBrowserHistory from 'history/createBrowserHistory';
import mixpanel from 'mixpanel-browser';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';

import { setItemSession } from 'src/actions/setItem';
import NotFound from '../web/Route/Route404';
import ImpersonateComponent from './containers/ImpersonateComponent';
import Prakerja from './info/Prakerja';
import Privacy from './info/Privacy';
import Terms from './info/Terms';
import KpjRedeemVerify from './kpj/KpjRedeemVerify';
import TugasMandiriDetail from './studentprofile_new/tugas-mandiri/TugasMandiriDetail';

// History instance
const history = createBrowserHistory();
history.listen(() => window.scrollTo(0, 0));

const trackingId = 'UA-163767507-1';

const App = () => {
  useEffect(() => {
    // Init GA
    ReactGA.initialize(trackingId, { debug: false });
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);

    // Init Facebook Pixel
    ReactPixel.init('915068772310431');
    ReactPixel.pageView();

    // Init Mixpanel
    mixpanel.init('939d679fde8f95f53f390d41a06f24ec');
    mixpanel.track('Landing');

    // Track IP
    trackUserIp();

    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

      utmKeys.forEach((key) => {
        const value = params.get(key);
        if (value) {
          setItemSession({ key, value });
        }
      });
    }

    // Listen route changes
    const unlisten = history.listen(() => {
      ReactGA.set({ page: window.location.pathname });
      ReactGA.pageview(window.location.pathname);
    });

    return () => {
      unlisten();
    };
  }, []);

  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/" component={LandingPageNew} />
        <Route exact path="/refer/:referral_id">
          <LandingPageNew refer={true} />
        </Route>

        <Route exact path="/voucher/verify" component={VerifyVoucherLayout} />
        <Route exact path="/voucher/verifylogin" component={VerifyLoginVoucherLayout} />
        <Route exact path="/courses" component={CourseListing} />
        <Route exact path="/course/login/:slug/:slug_url" component={CourseHostedLogin} />
        <Route exact path="/course/:slug/:slug_url" component={CourseDetail} />
        <Route exact path="/certificateverify/:id/" component={CertificateVerify} />

        <Route exact path="/coursedetail/:slug/:slug_url" component={CourseDetail} />
        <Route exact path="/contactus" component={KontakPage} />
        <Route exact path="/faq" component={FaqNew} />
        <Route exact path="/terms" component={Terms} />
        <Route exact path="/privacy" component={Privacy} />
        <Route exact path="/prakerja" component={Prakerja} />
        <Route exact path="/instructors" component={Instructors} />
        <Route
          exact
          path="/instructors/:instructor_id/:instructor_url"
          component={InstructorsDetail}
        />
        <Route exact path="/reset" component={LandingPageNew} />
        <Route exact path="/verify" component={LandingPageNew} />
        <Route exact path="/impersonate/:access_token" component={ImpersonateComponent} />

        <Route exact path="/intern" component={InternPage} />
        <Route exact path="/intern/:id" component={DetailInternPage} />

        <Route exact path="/checkoutsuccess/:type/:id" component={CheckoutPage} />

        <Route exact path="/order/detail" component={OrderDetail} />

        <Route exact path="/complete-on-boarding" component={OnBoardingRegister} />

        <Route
          exact
          path="/markattendance/:course_id/:schedule_id/:is_qna_session"
          component={MarkAttendance}
        />

        <ProtectedRoute exact path="/student/tugas-mandiri/:slug" component={TugasMandiriDetail} />

        <ProtectedRoute exact path="/student/:profile_menu" component={StudentDashboard} />

        <ProtectedRoute exact path="/kpj/redeem-verify" component={KpjRedeemVerify} />

        <Route component={NotFound} />
      </Switch>

      <WAButton />
    </Router>
  );
};

export default App;
